export default __webpack_public_path__ + "static/media/Unverified.a1ed7594.svg";